// extracted by mini-css-extract-plugin
module.exports = {"content":"AccordionContent_content__GowS5","slide-down":"AccordionContent_slide-down__LrcX9","slide-up":"AccordionContent_slide-up__JoYKG"};